import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative min-h-screen bg-obsidian font-sans text-slate-50">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
